configureAuthInterceptors.$inject = ["$httpProvider"];TokenInterceptor.$inject = ["$localStorage"];AuthInterceptor.$inject = ["$rootScope", "$q"];import { login as sharedLogin } from "../../shared/helpers/login";
import { logout as sharedLogout } from "../../shared/helpers/logout";
import { toJson } from "../../shared/helpers/to-json";

/**
                                                        * @namespace AuthenticationNew
                                                        * @returns {Factory}
                                                        */AuthenticationNew.$inject = ["$rootScope", "$cookies", "$state", "$http", "$window", "$q", "cfpLoadingBar", "gplansConf", "$localStorage", "UserService", "$cacheFactory"];
export function AuthenticationNew(
$rootScope,
$cookies,
$state,
$http,
$window,
// $analytics,
$q,
cfpLoadingBar,
gplansConf,
$localStorage,
// Profile,
UserService,
$cacheFactory)
{
  "ngInject";
  /**
               * @name AuthenticationNew
               * @desc The Factory to be returned
               */
  var AuthenticationNew = {
    getAuthenticatedAccount: getAuthenticatedAccount,
    isAuthenticated: isAuthenticated,
    isAuthenticatedAsync: isAuthenticatedAsync,
    login: login,
    logout: logout,
    check: check,
    getUID: getUID,
    facebookConnect: facebookConnect,
    facebookDisconnect: facebookDisconnect,
    facebookLogin: facebookLogin,
    facebookRegister: facebookRegister,
    register: register,
    createAccount: createAccount,
    getToken: getToken,
    setToken: setToken,
    setAuthenticatedAccount: setAuthenticatedAccount,
    unauthenticate: unauthenticate,
    resetAccount: resetAccount,
    sendQuizCompleteLink: sendQuizCompleteLink };


  return AuthenticationNew;

  /**
                             * @name getAuthenticatedAccount
                             * @desc Return the currently authenticated account
                             * @returns {object|undefined} Account if authenticated, else `undefined`
                             * @memberOf gplans.authentication.services.AuthenticationNew
                             */
  function getAuthenticatedAccount(check_now) {
    return UserService.getCurrentUser(check_now);
  }

  /**
     * @name getToken
     * @desc Return the currently authenticated token
     * @returns {string|undefined} token if authenticated, else `undefined`
     * @memberOf gplans.authentication.services.AuthenticationNew
     */
  function getToken() {
    return $localStorage['authToken'];
  }

  /**
     * @name setToken
     * @desc Set the authenticated token
     * @returns {undefined}
     * @memberOf gplans.authentication.services.AuthenticationNew
     */

  function setToken(token) {
    $localStorage['authToken'] = token;
  }

  /**
     * @name isAuthenticated
     * @desc Check if the current user is authenticated
     * @returns {boolean} True is user is authenticated, else false.
     * @memberOf gplans.authentication.services.AuthenticationNew
     */
  function isAuthenticated() {
    var account = $localStorage['authenticatedAccount'];
    var token = $localStorage['authToken'];

    if (account && token) {
      return true;
    } else {
      return false;
    }
  }

  function isAuthenticatedAsync() {var checkNow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var defer = $q.defer();

    var checkInterval = Date.now() - 1000 * 60 * 10; // 10 minutes
    var checkedAt = $localStorage['accountLastChecked'];

    if (
    !checkNow &&
    AuthenticationNew.isAuthenticated() &&
    checkedAt && Date.now() - checkedAt < checkInterval)
    {

      defer.resolve(true);

    } else {

      $localStorage['accountLastChecked'] = Date.now();
      AuthenticationNew.check().
      then(function () {return defer.resolve(true);}).
      catch(defer.reject);
    }
    return defer.promise;
  }

  /**
     * @name setAuthenticatedAccount
     * @desc Stringify the account object and store it in a cookie
     * @param {Object} user The account object to be stored
     * @returns {undefined}
     * @memberOf gplans.authentication.services.AuthenticationNew
     */
  function setAuthenticatedAccount(account) {
    if (!account || !account.id) return;
    $localStorage['authenticatedAccount'] = account;
  }

  /**
     * @name unauthenticate
     * @desc Reset all places where the user object is stored
     * @returns {undefined}
     * @memberOf gplans.authentication.services.AuthenticationNew
     */
  function unauthenticate() {
    UserService.reset();
    $localStorage.$reset();
    delete $rootScope.user;
    delete $localStorage.authToken;
    delete $localStorage.authenticatedAccount;
    delete $localStorage.accountLastChecked;
    angular.forEach($cacheFactory.info(), function (ob, key) {
      $cacheFactory.get(key).removeAll();
    });
  }

  /**
     * @name resetAccount
     * @desc Delete cookies, gplansStorage, go to the beginning of registration flow
     * @returns {undefined}
     * @memberOf gplans.authentication.services.AuthenticationNew
     */
  function resetAccount() {
    // don't clear cookies -> that'll destroy affilate info
    // clear cookies
    // var cookies = document.cookie.split(";");
    //
    // for (var i = 0; i < cookies.length; i++) {
    //   var cookie = cookies[i];
    //   var eqPos = cookie.indexOf("=");
    //   var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    //   document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    // }

    // clear gplansStorage, but preserve offerId
    var offerId = window.gplansStorage.offerId;
    var customCheckoutPage = window.gplansStorage.customCheckoutPage;

    if (offerId) window.gplansStorage.offerId = offerId;
    if (customCheckoutPage) window.gplansStorage.customCheckoutPage = customCheckoutPage;

    AuthenticationNew.logout().
    then(logoutCbFn, logoutErrFn);


    function logoutCbFn() {
      if (offerId == 'straightSale')
      $state.go('base.store_payment_before_quiz').then(function () {
        $window.location.reload();
      });else
      if (!offerId)
      $state.go('base.select_meta').then(function () {
        $window.location.reload();
      });else

      $state.go('base.survey_start').then(function () {
        $window.location.reload();
      });
    }

    function logoutErrFn(err) {
      console.warn('resetAccount error', err);
    }
  }

  ////////////////////

  /**
   * @name register
   * @desc Try to register a new user
   * @param {string} email The email entered by the user
   * @param {string} password The password entered by the user
   * @param {string} username The username entered by the user
   * @returns {Promise}
   * @memberOf gplans.authentication.services.AuthenticationNew
   */
  function register(email, password, username) {
    return $http.post(gplansConf.API_URL + '/api/v1/auth/register/', {
      username: username,
      password: password,
      email: email }).
    then(registerSuccessFn, registerErrorFn);

    /**
                                               * @name registerSuccessFn
                                               * @desc Log the new user in
                                               */
    function registerSuccessFn(data, status, headers, config) {
      AuthenticationNew.login(email, password);
      // Snackbar.show('Your account has been created.');
    }

    /**
       * @name registerErrorFn
       * @desc Log "Epic failure!" to the console
       */
    function registerErrorFn(data, status, headers, config) {
      return $q.reject(data);
    }
  }

  /**
     * @name sendQuizCompleteLink
     * @desc Try to register a new user
     * @param {string} email The email to send link
     * @returns {Promise}
     * @memberOf gplans.authentication.services.AuthenticationNew
     */
  function sendQuizCompleteLink(email) {
    return $http.post(gplansConf.API_URL + '/api/v1/auth/quiz-complete-link/', {
      email: email }).
    then(successFn, errorFn);

    /**
                               * @name successFn
                               * @desc Log the new user in
                               */
    function successFn(data, status, headers, config) {
      console.log('Check your mailbox');
      return data.data;
    }

    /**
       * @name errorFn
       * @desc Log "Epic failure!" to the console
       */
    function errorFn(data, status, headers, config) {
      console.log('Something went wrong!', data.data);
      return $q.reject(data);
    }
  }

  /**
     * @name createAccount
     * @desc create account for user without pass (pass will be set later in same sesssion)
     * @param {string} email The email entered by the user
     * @returns {Promise}
     * @memberOf gplans.authentication.services.AuthenticationNew
     */
  function createAccount(oAccount, nextState, nextParams) {
    return UserService.create(oAccount).
    then(createAccountSuccessFn, createAccountErrorFn);

    /**
                                                         * @name rcreateAccountSuccessFn
                                                         * @desc Log the new user in
                                                         */
    function createAccountSuccessFn(data, status, headers, config) {
      $localStorage['authToken'] = data.token;
      AuthenticationNew.setAuthenticatedAccount(data.user);
      if (angular.isDefined(nextState))
      $state.go(nextState, nextParams);
      return data;
    }

    /**
       * @name createAccountErrorFn
       * @desc Log "Epic failure!" to the console
       */
    function createAccountErrorFn(data, status, headers, config) {
      console.error(data);
      return $q.reject(data);
    }
  }

  /**
     * @name facebookLogin
     * @desc Try to log in with Facebook api
     * @param {string} accessToken The token facebook gave back for the user
     * @returns {Promise}
     * @memberOf gplans.authentication.services.AuthenticationNew
     */
  function facebookLogin(accessToken) {
    return $http.post(gplansConf.API_URL + '/api/v1/auth/facebook/login/', {
      accessToken: accessToken }).
    then(loginSuccessFn, loginErrorFn);

    /**
                                         * @name loginSuccessFn
                                         * @desc Set the authenticated account and redirect to index
                                         */
    function loginSuccessFn(data, status, headers, config) {
      $localStorage['authToken'] = data.data.token;
      var userData = data.data.user;
      AuthenticationNew.setAuthenticatedAccount(userData);
      UserService.set(userData);
      _analyticsSetUser(userData);
      // window.location = '/app/';
      if ($rootScope.redirectTo) {
        window.location = '/app/dash' + $rootScope.redirectTo;
        $rootScope.redirectTo = null;
      } else
      {
        $state.go('gplans.userConsole');
      }
      //Snackbar.show('Welcome back.');
    }

    /**
       * @name loginErrorFn
       * @desc Log "Epic failure!" to the console
       */
    function loginErrorFn(data, status, headers, config) {
      return $q.reject(data);
    }
  }

  /**
     * @name facebookRegister
     * @desc Try to sign up with Facebook api
     * @param {string} accessToken The token facebook gave back for the user
     * @param {string} userSurveyPk Initial Survey data we get from user
     * @returns {Promise}
     * @memberOf gplans.authentication.services.AuthenticationNew
     */
  function facebookRegister(accessToken, userSurveyPk) {
    return $http.post(gplansConf.API_URL + '/api/v1/auth/facebook/register/', {
      accessToken: accessToken,
      user_survey_pk: userSurveyPk }).
    then(registerSuccessFn, registerErrorFn);

    /**
                                               * @name registerSuccessFn
                                               * @desc Set the authenticated account
                                               */
    function registerSuccessFn(data, status, headers, config) {
      $localStorage['authToken'] = data.data.token;
      AuthenticationNew.setAuthenticatedAccount(data.data.user);
      UserService.set(data.data.user);
      return data.data;
    }

    /**
       * @name registerErrorFn
       * @desc Log "Epic failure!" to the console
       */
    function registerErrorFn(data, status, headers, config) {
      //Snackbar.show(data.data.message);
      return $q.reject(data);
    }
  }

  /**
     * @name facebookDisconnect
     * @desc Destroy the logged in user's Facebook SocialProfile
     * @returns {Promise}
     * @memberOf gplans.authentication.services.AuthenticationNew
     */
  function facebookDisconnect(accessToken) {
    return $http.post(gplansConf.API_URL + '/api/v1/auth/facebook/disconnect/').
    then(disconnectSuccessFn, disconnectErrorFn);

    /**
                                                   * @name disconnectSuccessFn
                                                   * @desc Set the authenticated account and redirect to index
                                                   */
    function disconnectSuccessFn(data, status, headers, config) {
      var userData = data.data;
      AuthenticationNew.setAuthenticatedAccount(userData);
      UserService.set(userData);
      _analyticsSetUser(userData);
      //Snackbar.show('Disconnected to facebook successfully.');
    }

    /**
       * @name disconnectErrorFn
       * @desc Log "Epic failure!" to the console
       */
    function disconnectErrorFn(data, status, headers, config) {
      return $q.reject(data);
    }
  }

  /**
     * @name facebookConnect
     * @desc Try to log in with Facebook api
     * @param {string} accessToken The token facebook gave back for the user
     * @returns {Promise}
     * @memberOf gplans.authentication.services.AuthenticationNew
     */
  function facebookConnect(accessToken) {
    return $http.post(gplansConf.API_URL + '/api/v1/auth/facebook/connect/', {
      accessToken: accessToken }).
    then(connectSuccessFn, connectErrorFn);

    /**
                                             * @name connectSuccessFn
                                             * @desc Set the authenticated account and redirect to index
                                             */
    function connectSuccessFn(data, status, headers, config) {
      var userData = data.data;
      AuthenticationNew.setAuthenticatedAccount(userData);
      UserService.set(userData);
      _analyticsSetUser(userData);
      //Snackbar.show('Connected to facebook successfully.');
    }

    /**
       * @name connectErrorFn
       * @desc Log "Epic failure!" to the console
       */
    function connectErrorFn(data, status, headers, config) {
      return $q.reject(data);
    }
  }

  /**
     * @name login
     * @desc Try to log in with email `email` and password `password`
     * @param {string} email The email entered by the user
     * @param {string} password The password entered by the user
     * @returns {Promise}
     * @memberOf gplans.authentication.services.AuthenticationNew
     */
  function login(email, password) {
    cfpLoadingBar.start();
    return $q(function (rs, rj) {return sharedLogin({ email: email, password: password }).then(rs).catch(rj);}).
    then(loginSuccessFn).
    catch(loginErrorFn).
    finally(function () {
      cfpLoadingBar.complete();
    });


    function loginSuccessFn(data, status, headers, config) {
      $localStorage.$sync();
      AuthenticationNew.setToken(data.token);
      AuthenticationNew.setAuthenticatedAccount(data.user);
      UserService.set(data.user);
    }

    function loginErrorFn(data, status, headers, config) {
      console.warn('login error', data, status);
      return $q.reject(data);
    }
  }

  /**
     * @name check
     * @desc Try to log in with email `email` and password `password`
     * @param {string} email The email entered by the user
     * @param {string} password The password entered by the user
     * @returns {Promise}
     * @memberOf gplans.authentication.services.AuthenticationNew
     */
  function check() {
    return $http.post(gplansConf.API_URL + '/api/v1/auth/check/', {}).
    then(checkSuccessFn, checkErrorFn);

    /**
                                         * @name checkSuccessFn
                                         * @desc Set the authenticated account and redirect to index
                                         */
    function checkSuccessFn(data, status, headers, config) {
      AuthenticationNew.setToken(data.data.token);
      var userData = data.data.user;
      AuthenticationNew.setAuthenticatedAccount(userData);
      UserService.set(userData);
      _analyticsSetUser(UserService.data);
      console.log('Yeah you are still logged in.', data.data);
      return data;
    }

    /**
       * @name checkErrorFn
       * @desc Log "Epic failure!" to the console
       */
    function checkErrorFn(data, status, headers, config) {
      AuthenticationNew.unauthenticate();
      console.warn('auth check failed', data, status);
      return $q.reject(data);
    }
  }

  /**
     * @name getUID
     * @desc get uid for current user
     * @returns {Promise}
     * @memberOf gplans.authentication.services.AuthenticationNew
     */
  function getUID() {
    return $http.get(gplansConf.API_URL + '/api/v1/accounts/uid/', {}).then(getUIDSuccessFn, getUIDErrorFn);

    /**
                                                                                                              * @name getUIDSuccessFn
                                                                                                              * @desc Set the authenticated account and redirect to index
                                                                                                              */
    function getUIDSuccessFn(data, status, headers, config) {
      return data.data.uid;
    }

    /**
       * @name getUIDErrorFn
       * @desc Log "Epic failure!" to the console
       */
    function getUIDErrorFn(data, status, headers, config) {
      return $q.reject(data);
    }
  }

  /**
     * @name logout
     * @desc Try to log the user out
     * @returns {Promise}
     * @memberOf gplans.authentication.services.AuthenticationNew
     */
  function logout() {
    cfpLoadingBar.start();
    return $q(function (rs, rj) {return sharedLogout().then(rs).catch(rj);}).
    then(function () {
      $localStorage.$sync();
      return AuthenticationNew.unauthenticate();
    }).
    then(function () {
      return $state.go('gplans.auth.login', {}, { reload: true });
    }).
    catch(function (data, status, headers, config) {
      console.error('Logout error:', data, status, headers, config);
      return $q.reject(data);
    }).
    finally(function () {
      cfpLoadingBar.complete();
    });

  }

  function _analyticsSetUser(userData) {
    if (userData.email) {
      // todo: that's same as in Intercom service boot function. Should be DRY somehow.
      // $analytics.setUsername(UserService.data.username);
      var props = {};
      if (userData.age) props.age = userData.age;
      if (userData.uid) props.uid = userData.uid;
      if (userData.intercom_id) props.intercom_id = userData.intercom_id;
      if (userData.gender) props.gender = userData.gender;
      if (userData.email) props.email = userData.email;
      props.name = '';
      if (userData.first_name) props.name += userData.first_name;
      if (props.name && userData.last_name) props.name += ' ';
      if (userData.last_name) props.name += userData.last_name;
      if (userData.date_joined) props.created_at = Math.round(new Date(userData.date_joined).getTime() / 1000);
      if (userData.subscription_plan && userData.subscription_plan.name) props.plan = userData.subscription_plan.name;
      if ($rootScope.showTwoWeeksAcceleratorBadge) props['Two Weeks Accelerator'] = true;
      // $analytics.setUserProperties(props);
    }
  }
}

function AuthInterceptor($rootScope, $q) {
  "ngInject";
  return {
    responseError: function responseError(response) {
      $rootScope.$broadcast({
        401: 'AUTH_EVENTS:notAuthenticated',
        403: 'AUTH_EVENTS:forbidden' }[
      response.status], response);
      return $q.reject(response);
    } };

}

function TokenInterceptor($localStorage) {
  "ngInject";
  return {
    request: function request(config) {
      if (
      angular.isString(config.url) &&
      config.url.startsWith(gplansConf.API_URL) &&
      !!$localStorage['authToken'])
      {
        config.headers['Authorization'] = 'Token ' + $localStorage['authToken'];
      }
      return config;
    } };

}

export function configureAuthInterceptors($httpProvider) {
  "ngInject";
  $httpProvider.interceptors.push(AuthInterceptor);
  $httpProvider.interceptors.push(TokenInterceptor);
}